<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5 text-uppercase" >{{page}}</h2>
      </div>
      <div class="d-flex">
        <div class="justify-content-center">
          <router-link :to="`/${url}/add`" type="button" class="btn btn-primary my-2 btn-icon-text">
            <i class="fe fe-plus-square mr-2"></i> Add {{page}}
          </router-link>
        </div>
      </div>
    </div>
    <div class="row row-sm">
      <div class="col-lg-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">{{page}} List</h6>
            </div>
            <div class="table-responsive">
              <div class="form-group mt-1 ml-1" style="width: 280px">
                <div class="d-flex">
                  <div class="input-group rounded">
                    <input type="search" class="form-control rounded" v-model="searchText" v-on:keyup.enter="search" placeholder="Search"/>
                    <button type="button" class="border-0 btn btn-primary" @click="search">
                      <i class="fas fa-search"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table striped hover :items="dataList" :fields="tableFields">
                <template #cell(email_verified)="row">
                  <span v-if="row.item.email_verified" class="badge badge-success">Verified</span>
                  <span v-else class="badge badge-danger">Not Verified</span>
                </template>
                <template #cell(actions)="row">
                  <button v-if="!row.item.blocked" @click="blockedItem(row.item)" type="button" class="btn btn-outline-danger mr-2 mt-1 mb-1">
                    <i class="fe fe-lock"></i>
                  </button>
                  <button v-else @click="blockedItem(row.item)" type="button" class="btn btn-outline-success mr-2 mt-1 mb-1">
                    <i class="fe fe-unlock"></i>
                  </button>
                  <router-link :to="`/${url}/${row.item.id}`" class="btn btn-outline-primary mr-2 mt-1 mb-1">
                    <i class="fe fe-edit"></i>
                  </router-link>
                  <button v-if="!row.item.deleted_at" @click="removeItem(row.item.id)" type="button" class="btn btn-outline-danger mr-2 mt-1 mb-1">
                    <i class="ti-close"></i>
                  </button>
                  <button v-if="!row.item.deleted_at" @click="userLogin(row.item.id)" type="button" class="btn btn-outline-primary mr-2 mt-1 mb-1">
                    <i class="ti-user"></i>
                  </button>
                  <div v-else class="d-inline-block">
                    <button @click="restoreItem(row.item.id)" type="button" class="btn btn-outline-success mr-2 mt-1 mb-1">
                      <i class="fe fe-rotate-ccw"></i>
                    </button>
                    <button @click="forceRemoveItem(row.item.id)" type="button" class="btn btn-outline-danger mr-2 mt-1 mb-1">
                      <i class="fe fe-trash-2"></i>
                    </button>
                  </div>
                </template>
              </b-table>
              <div class="d-flex justify-content-end  mt-3">
                <div class="mr-3">
                  <b-form-select
                    @change="changePaginationPerPage"
                    style="width: 80px"
                    v-model="paginationPerPage"
                    :options="paginationOptions"
                  >
                  </b-form-select>
                </div>
                <div>
                  <b-pagination
                    class="m-0"
                    @change="changePagination"
                    v-model="paginationCurrentPage"
                    :total-rows="pagination.count"
                    :per-page="paginationPerPage"
                    first-text="<<"
                    prev-text="<"
                    next-text=">"
                    last-text=">>"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal hide-footer ref="removeItemModal" size="md">
      <div class="main-mail-compose-box ">
        <div class="swal2-icon swal2-warning swal2-icon-show" style="display: flex;"><div class="swal2-icon-content">!</div></div>
        <div class="d-flex justify-content-center">
          <p v-if="isBlockedItem">Are you sure you want to blocked?</p>
          <p v-else>{{$t('messages.warning.delete')}}</p>
        </div>
        <ValidationObserver ref="currencyAddForm" id="articleAddForm" tag="form" class="d-flex flex-column px-4" @submit.prevent="formSubmit()">
          <b-tabs content-class="mt-3">
            <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
              <label for="first_name" class="form-label">Reason:</label>
              <textarea id="first_name" class="form-control" name="first_name" v-model="formData.reason" :class="checkValidation(classes)" placeholder="reason"></textarea>
            </ValidationProvider>
          </b-tabs>
          <div class="d-flex justify-content-center mb-3">
            <button class="btn ripple btn-success mt-2 mr-2" >Yes</button>
            <button @click="closeRemoveItemModal" type="button" class="btn ripple btn-danger mt-2" >No</button>
          </div>
        </ValidationObserver>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Swal from 'sweetalert2'
const page = 'user'
const url = 'user'
export default {
  name: 'roomBase',
  data () {
    return {
      page: page,
      url: url,
      paginationOptions: [
        { value: 6, text: '6' },
        { value: 10, text: '10' },
        { value: 30, text: '30' },
        { value: 100, text: '100' }
      ],
      isBlockedItem: false,
      itemId: null,
      searchText: '',
      paginationCurrentPage: 1,
      paginationPerPage: 6,
      pagination: {},
      formData: {}
    }
  },
  computed: {
    ...mapState({
      dataList: state => state[page].dataList
    }),
    tableFields () {
      return [
        {
          key: 'id',
          label: 'Id',
          sortable: true
        },
        {
          key: 'email',
          label: 'Email',
          sortable: true
        },
        {
          key: 'first_name',
          label: 'First name',
          sortable: true
        },
        {
          key: 'last_name',
          label: 'Last name',
          sortable: true
        },
        {
          key: 'phone',
          label: 'Phone',
          sortable: true
        },
        {
          key: 'gender',
          label: 'Gender',
          sortable: true
        },
        {
          key: 'email_verified',
          label: 'Email Verified',
          sortable: true
        },
        {
          key: 'blocked_reason',
          label: 'Blocked reason',
          sortable: true
        },
        {
          key: 'deleted_reason',
          label: 'Deleted reason',
          sortable: true
        },
        {
          key: 'actions',
          sortable: false
        }
      ]
    }
  },
  created () {
    this.getData({ count: this.paginationPerPage })
  },
  methods: {
    ...mapActions({
      getAllData: page + '/getAllData',
      deleteItem: page + '/delete',
      deleteForce: page + '/deleteForce',
      restore: page + '/restore',
      loginUser: page + '/loginUser',
      unblock: page + '/unblock',
      blocked: page + '/blocked'
    }),
    checkValidation (data) {
      return data
    },
    getData (params) {
      this.getAllData(params).then(res => {
        this.pagination = res.pagination
      }).catch(err => {
        if (err && err.response) {
          if (err.response.status === 422) {
            const data = err.response.data.errors
            const keys = Object.keys(data)
            const msg = data[keys[0]]
            this.$toasted.error(msg).goAway(1500)
          } else {
            this.$toasted.error(err.response.message).goAway(1500)
          }
        }
      })
    },
    search () {
      this.getData({ page: this.paginationCurrentPage, count: this.paginationPerPage, search: this.searchText })
    },
    changePaginationPerPage (value) {
      this.getData({ page: this.paginationCurrentPage, count: value, search: this.searchText })
    },
    changePagination (page) {
      this.getData({ page: page, count: this.paginationPerPage, search: this.searchText })
    },
    closeRemoveItemModal () {
      this.itemId = null
      this.$refs.removeItemModal.hide()
    },
    removeItem (id) {
      this.isBlockedItem = false
      this.itemId = id
      this.$refs.removeItemModal.show()
    },
    blockedItem (item) {
      if (!item.blocked) {
        this.isBlockedItem = true
        this.itemId = item.id
        this.$refs.removeItemModal.show()
      } else {
        Swal.fire({
          text: 'Are you sure you want to unblock?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#748C41',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('buttons.yes'),
          cancelButtonText: this.$t('buttons.no')
        }).then((result) => {
          if (result.value) {
            this.unblock({ id: item.id }).then(res => {
            }).catch(err => {
              if (err && err.response) {
                if (err.response.status === 422) {
                  const data = err.response.data.errors
                  const keys = Object.keys(data)
                  const msg = data[keys[0]]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.message).goAway(1500)
                }
              }
            })
          }
        })
      }
    },
    forceRemoveItem (id) {
      Swal.fire({
        text: this.$t('messages.warning.delete'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#748C41',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then((result) => {
        if (result.value) {
          this.deleteForce({ id }).then(res => {
          }).catch(err => {
            if (err && err.response) {
              if (err.response.status === 422) {
                const data = err.response.data.errors
                const keys = Object.keys(data)
                const msg = data[keys[0]]
                this.$toasted.error(msg).goAway(1500)
              } else {
                this.$toasted.error(err.response.message).goAway(1500)
              }
            }
          })
        }
      })
    },
    userLogin (id) {
      const vetourio = 'https://ventourio.com'
      this.loginUser({ id }).then((res) => {
        sessionStorage.setItem('hash', JSON.stringify(res.hash))
        window.open(`${vetourio}?hash=${res.hash}&id=${id}`)
      }).catch(err => {
        if (err && err.response) {
          if (err.response.status === 422) {
            const data = err.response.data.errors
            const keys = Object.keys(data)
            const msg = data[keys[0]]
            this.$toasted.error(msg).goAway(1500)
          } else {
            this.$toasted.error(err.response.message).goAway(1500)
          }
        }
      })
    },
    restoreItem (id) {
      Swal.fire({
        text: 'Are you sure you want to restore?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#748C41',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then((result) => {
        if (result.value) {
          this.restore({ id }).then(res => {
          }).catch(err => {
            if (err && err.response) {
              if (err.response.status === 422) {
                const data = err.response.data.errors
                const keys = Object.keys(data)
                const msg = data[keys[0]]
                this.$toasted.error(msg).goAway(1500)
              } else {
                this.$toasted.error(err.response.message).goAway(1500)
              }
            }
          })
        }
      })
    },
    formSubmit () {
      this.$refs.currencyAddForm.validate().then(success => {
        if (success) {
          if (this.isBlockedItem) {
            this.blocked({ id: this.itemId, reason: this.formData.reason }).then(res => {
              this.formData = {}
              this.$refs.removeItemModal.hide()
            }).catch(err => {
              if (err && err.response) {
                if (err.response.status === 422) {
                  const data = err.response.data.errors
                  const keys = Object.keys(data)
                  const msg = data[keys[0]]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.message).goAway(1500)
                }
              }
            })
          } else {
            this.deleteItem({ id: this.itemId, reason: this.formData.reason }).then(res => {
              this.formData = {}
              this.$refs.removeItemModal.hide()
            }).catch(err => {
              if (err && err.response) {
                if (err.response.status === 422) {
                  const data = err.response.data.errors
                  const keys = Object.keys(data)
                  const msg = data[keys[0]]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.message).goAway(1500)
                }
              }
            })
          }
        }
      })
    }
  }
}
</script>

<style>
  .is_main {
    transform: scale(1.5);
    -ms-transform: scale(1.5);
    -webkit-transform: scale(1.5);
    cursor: pointer;
  }
  .modal-header {
    border-bottom: none !important;
  }
</style>
